import { render, staticRenderFns } from "./BannerSettingModal.vue?vue&type=template&id=a47d1782&scoped=true"
import script from "./BannerSettingModal.ts?vue&type=script&lang=ts&external"
export * from "./BannerSettingModal.ts?vue&type=script&lang=ts&external"
import style0 from "./BannerSettingModal.vue?vue&type=style&index=0&id=a47d1782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47d1782",
  null
  
)

export default component.exports